import React, { useState } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Button } from '@/components/ui/button';
import { Label } from '@/components/ui/label';
import { CalculationHistory } from '@/components/CalculationHistory';
import { useCalculationHistory } from '@/hooks/useCalculationHistory';

export const PercentageOf: React.FC = () => {
  const [value1, setValue1] = useState<string>('');
  const [value2, setValue2] = useState<string>('');
  const [result, setResult] = useState<number | null>(null);
  const { history, favorites, addCalculation, toggleFavorite, clearHistory } = useCalculationHistory();

  const calculate = () => {
    const val1 = parseFloat(value1);
    const val2 = parseFloat(value2);
    
    if (!isNaN(val1) && !isNaN(val2) && val2 !== 0) {
      const calculatedResult = (val1 / val2) * 100;
      setResult(calculatedResult);
      
      // Add to history
      addCalculation(
        'percentage-of',
        { value1: val1, value2: val2 },
        `${calculatedResult.toFixed(2)}%`
      );
    }
  };

  return (
    <Card className="shadow-card">
      <CardHeader>
        <CardTitle className="text-lg font-semibold text-card-foreground">
          X is what % of Y?
        </CardTitle>
      </CardHeader>
      <CardContent className="space-y-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="space-y-2">
            <Label htmlFor="value1" className="text-sm font-medium">
              Value (X)
            </Label>
            <Input
              id="value1"
              type="number"
              placeholder="Enter first value"
              value={value1}
              onChange={(e) => setValue1(e.target.value)}
              className="h-12"
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="value2" className="text-sm font-medium">
              Total Value (Y)
            </Label>
            <Input
              id="value2"
              type="number"
              placeholder="Enter total value"
              value={value2}
              onChange={(e) => setValue2(e.target.value)}
              className="h-12"
            />
          </div>
        </div>
        
        <Button 
          onClick={calculate}
          className="w-full h-12 bg-calculator-gradient hover:opacity-90 transition-opacity"
        >
          Calculate
        </Button>
        
        {result !== null && (
          <div className="p-4 bg-primary/5 border border-primary/20 rounded-lg shadow-result">
            <p className="text-sm text-muted-foreground mb-1">Result:</p>
            <p className="text-2xl font-bold text-primary">
              {result.toFixed(2)}%
            </p>
          </div>
        )}
        
        <CalculationHistory
          history={history.filter(item => item.type === 'percentage-of')}
          favorites={favorites}
          onToggleFavorite={toggleFavorite}
          onClearHistory={clearHistory}
        />
      </CardContent>
    </Card>
  );
};